import { c as _c } from "react/compiler-runtime";
import StrapiImage from "@components/StrapiImage";
import { UploadFileEntityResponse } from "@lib/generated/graphql";
import { FC } from "react";
interface IconProps {
  icon: UploadFileEntityResponse;
}
const Icon: FC<IconProps> = t0 => {
  const $ = _c(2);
  const {
    icon
  } = t0;
  if (!icon.data) {
    return null;
  }
  let t1;
  if ($[0] !== icon) {
    t1 = <div className="relative mb-3s w-full max-w-[100px] m:max-w-[140px] aspect-square"><StrapiImage alt="" fill={true} sizes="(max-width: 960px) 100px, 140px" image={icon} className="object-contain" /></div>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Icon;